import { render, staticRenderFns } from "./InquiryHistory.vue?vue&type=template&id=de747bba&scoped=true"
import script from "./InquiryHistory.vue?vue&type=script&lang=js"
export * from "./InquiryHistory.vue?vue&type=script&lang=js"
import style0 from "./InquiryHistory.vue?vue&type=style&index=0&id=de747bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de747bba",
  null
  
)

export default component.exports